import React, { useEffect, useRef } from 'react';
import { Ellipsis } from '@gravity-ui/icons';
import { Button, Icon, Menu, Popup } from '@gravity-ui/uikit';
import { i18n as i18nCommon } from '../../../../i18n/common';
import { useBooleanState } from '../../../../react-utils/hooks';
import { useNodeEditing } from '../../../../react-utils/useNodeEditing';
import { useNodeHovered } from '../../../../react-utils/useNodeHovered';
import { removeNode } from '../../../../utils/remove-node';
import { imageRendererKey } from '../const';
import { ImageForm } from './ImageForm';
export const ImgSettingsButton = function ({ node, view, getPos, nodeRef, updateAttributes }) {
    const [popupOpen, setPopupOpen, unsetPopupOpen] = useBooleanState(false);
    const placement = ['bottom-end', 'bottom-start'];
    const buttonRef = useRef(null);
    const isNodeHovered = useNodeHovered(nodeRef);
    const isButtonHovered = useNodeHovered(buttonRef);
    const [edit, setEditing, unsetEdit, toggleEdit] = useNodeEditing({ nodeRef, view });
    const visible = (isNodeHovered || isButtonHovered || popupOpen) && !edit;
    useEffect(() => {
        var _a;
        if ((_a = imageRendererKey.getState(view.state)) === null || _a === void 0 ? void 0 : _a.linkAdded) {
            setEditing();
        }
    }, [view, setEditing]);
    if (edit)
        return (React.createElement(ImageForm, { node: node, view: view, updateAttributes: updateAttributes, dom: nodeRef, unsetEdit: unsetEdit }));
    return visible ? (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: setPopupOpen, ref: buttonRef, size: "s", view: 'raised', style: { position: 'absolute', right: '3px', top: '3px' } },
            React.createElement(Icon, { data: Ellipsis })),
        React.createElement(Popup, { open: popupOpen, anchorRef: buttonRef, onClose: unsetPopupOpen, placement: placement },
            React.createElement(Menu, null,
                React.createElement(Menu.Item, { onClick: () => {
                        toggleEdit();
                        unsetPopupOpen();
                    } }, i18nCommon('edit')),
                React.createElement(Menu.Item, { onClick: () => {
                        const pos = getPos();
                        if (pos === undefined)
                            return;
                        removeNode({
                            node,
                            pos,
                            tr: view.state.tr,
                            dispatch: view.dispatch,
                        });
                        view.focus();
                    } }, i18nCommon('delete')))))) : null;
};
